import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Card from '@components/Card/Card';
import urls from '@routes/urls';

const MedicationStatusLookupCard: FC = () => {
  const { t } = useTranslation();

  return (
    <Card
      icon="/images/img-prescription-circle.svg"
      title={t('dashboardCards.medicationStatusLookup.title')}
      description={t('dashboardCards.medicationStatusLookup.description')}
      link={{
        title: t('dashboardCards.medicationStatusLookup.linkTitle'),
        routerLink: urls.medications,
      }}
    />
  );
};

export default MedicationStatusLookupCard;
